import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid py-4 px-4 metrics-view" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "metrics-eyebrow text-uppercase font-weight-bolder text-secondary letter-spacing-1 mb-2" }
const _hoisted_4 = { class: "row g-3 metrics-kpi-row" }
const _hoisted_5 = { class: "col-6 col-lg-3" }
const _hoisted_6 = { class: "card shadow h-100" }
const _hoisted_7 = { class: "card-body p-3" }
const _hoisted_8 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_9 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_10 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_11 = { class: "font-weight-bolder mb-0 me-2" }
const _hoisted_12 = { class: "col-6 col-lg-3" }
const _hoisted_13 = { class: "card shadow h-100" }
const _hoisted_14 = { class: "card-body p-3" }
const _hoisted_15 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_16 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_17 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_18 = { class: "font-weight-bolder mb-0 me-2" }
const _hoisted_19 = { class: "col-6 col-lg-3" }
const _hoisted_20 = { class: "card shadow h-100" }
const _hoisted_21 = { class: "card-body p-3" }
const _hoisted_22 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_23 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_24 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_25 = { class: "font-weight-bolder mb-0 me-2" }
const _hoisted_26 = { class: "col-6 col-lg-3" }
const _hoisted_27 = { class: "card shadow h-100" }
const _hoisted_28 = { class: "card-body p-3" }
const _hoisted_29 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_30 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_31 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_32 = {
  key: 0,
  class: "font-weight-bolder mb-0 me-2"
}
const _hoisted_33 = {
  key: 1,
  class: "font-weight-bolder mb-0 text-muted"
}
const _hoisted_34 = {
  key: 2,
  class: "text-sm font-weight-bolder text-secondary"
}
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "metrics-eyebrow text-uppercase font-weight-bolder text-secondary letter-spacing-1 mb-2" }
const _hoisted_37 = { class: "row g-3 metrics-kpi-row" }
const _hoisted_38 = { class: "col-6 col-lg-3" }
const _hoisted_39 = { class: "card shadow h-100" }
const _hoisted_40 = { class: "card-body p-3" }
const _hoisted_41 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_42 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_43 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_44 = { class: "font-weight-bolder mb-0 me-2" }
const _hoisted_45 = { class: "col-6 col-lg-3" }
const _hoisted_46 = { class: "card shadow h-100" }
const _hoisted_47 = { class: "card-body p-3" }
const _hoisted_48 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_49 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_50 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_51 = { class: "font-weight-bolder mb-0 me-2" }
const _hoisted_52 = { class: "text-xs text-muted mb-0 mt-1" }
const _hoisted_53 = { class: "col-6 col-lg-3" }
const _hoisted_54 = { class: "card shadow h-100" }
const _hoisted_55 = { class: "card-body p-3" }
const _hoisted_56 = { class: "d-flex align-items-start justify-content-between mb-2" }
const _hoisted_57 = { class: "text-xs text-uppercase font-weight-bolder text-secondary mb-0" }
const _hoisted_58 = { class: "d-flex align-items-baseline flex-wrap" }
const _hoisted_59 = { class: "font-weight-bolder mb-0 me-2" }
const _hoisted_60 = { class: "text-xs text-muted mb-0 mt-1" }
const _hoisted_61 = { class: "row g-3 mb-3" }
const _hoisted_62 = { class: "col-sm-6 col-xxl-4" }
const _hoisted_63 = { class: "card shadow" }
const _hoisted_64 = { class: "card-header d-flex align-items-center" }
const _hoisted_65 = { class: "mb-0 font-weight-bolder" }
const _hoisted_66 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-info ms-auto",
  role: "status"
}
const _hoisted_67 = { class: "card-body" }
const _hoisted_68 = { class: "metrics-legend" }
const _hoisted_69 = { class: "metrics-legend-item" }
const _hoisted_70 = { class: "metrics-legend-label" }
const _hoisted_71 = { class: "metrics-legend-item" }
const _hoisted_72 = { class: "metrics-legend-label" }
const _hoisted_73 = { class: "metrics-legend-item" }
const _hoisted_74 = { class: "metrics-legend-label" }
const _hoisted_75 = { class: "chart" }
const _hoisted_76 = { class: "d-flex justify-content-center" }
const _hoisted_77 = {
  key: 0,
  class: "fa-solid fa-spinner fa-10x circle"
}
const _hoisted_78 = { class: "col-sm-6 col-xxl-4" }
const _hoisted_79 = { class: "card shadow" }
const _hoisted_80 = { class: "card-header d-flex align-items-center" }
const _hoisted_81 = { class: "mb-0 font-weight-bolder" }
const _hoisted_82 = { class: "card-body" }
const _hoisted_83 = { class: "metrics-legend" }
const _hoisted_84 = { class: "metrics-legend-item" }
const _hoisted_85 = { class: "metrics-legend-label" }
const _hoisted_86 = { class: "chart" }
const _hoisted_87 = { class: "d-flex justify-content-center" }
const _hoisted_88 = {
  key: 0,
  class: "fa-solid fa-spinner fa-10x circle"
}
const _hoisted_89 = { class: "col-sm-6 col-xxl-4" }
const _hoisted_90 = { class: "card shadow" }
const _hoisted_91 = { class: "card-header d-flex align-items-center" }
const _hoisted_92 = { class: "mb-0 font-weight-bolder" }
const _hoisted_93 = {
  class: "metrics-segment ms-auto",
  role: "group"
}
const _hoisted_94 = { class: "card-body" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = {
  key: 0,
  class: "text-xs text-muted mb-0"
}
const _hoisted_97 = {
  key: 1,
  class: "metrics-top5-list"
}
const _hoisted_98 = { class: "metrics-top5-plate" }
const _hoisted_99 = { class: "metrics-top5-track" }
const _hoisted_100 = { class: "metrics-top5-count" }
const _hoisted_101 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_102 = { class: "row g-3" }
const _hoisted_103 = { class: "col-lg-7" }
const _hoisted_104 = { class: "card shadow h-100" }
const _hoisted_105 = { class: "card-header d-flex align-items-center" }
const _hoisted_106 = { class: "mb-0 font-weight-bolder" }
const _hoisted_107 = { class: "card-body" }
const _hoisted_108 = { class: "metrics-legend" }
const _hoisted_109 = { class: "metrics-legend-item" }
const _hoisted_110 = { class: "metrics-legend-label" }
const _hoisted_111 = { class: "metrics-legend-item" }
const _hoisted_112 = { class: "metrics-legend-label" }
const _hoisted_113 = { class: "chart" }
const _hoisted_114 = { class: "d-flex justify-content-center" }
const _hoisted_115 = {
  key: 0,
  class: "fa-solid fa-spinner fa-10x circle"
}
const _hoisted_116 = { class: "col-lg-5" }
const _hoisted_117 = { class: "card shadow h-100" }
const _hoisted_118 = { class: "card-header d-flex align-items-center" }
const _hoisted_119 = { class: "mb-0 font-weight-bolder" }
const _hoisted_120 = { class: "card-body" }
const _hoisted_121 = { class: "metrics-revenue-list" }
const _hoisted_122 = { class: "metrics-revenue-row" }
const _hoisted_123 = { class: "d-flex justify-content-between align-items-baseline mb-1" }
const _hoisted_124 = { class: "metrics-revenue-label" }
const _hoisted_125 = { class: "text-end" }
const _hoisted_126 = { class: "metrics-revenue-value" }
const _hoisted_127 = { class: "metrics-revenue-pct" }
const _hoisted_128 = { class: "metrics-revenue-track" }
const _hoisted_129 = { class: "metrics-revenue-row" }
const _hoisted_130 = { class: "d-flex justify-content-between align-items-baseline mb-1" }
const _hoisted_131 = { class: "metrics-revenue-label" }
const _hoisted_132 = { class: "metrics-revenue-sub" }
const _hoisted_133 = { class: "text-end" }
const _hoisted_134 = { class: "metrics-revenue-value" }
const _hoisted_135 = { class: "metrics-revenue-pct" }
const _hoisted_136 = { class: "metrics-revenue-track" }
const _hoisted_137 = { class: "metrics-revenue-row" }
const _hoisted_138 = { class: "d-flex justify-content-between align-items-baseline mb-1" }
const _hoisted_139 = { class: "metrics-revenue-label" }
const _hoisted_140 = { class: "metrics-revenue-sub" }
const _hoisted_141 = { class: "text-end" }
const _hoisted_142 = { class: "metrics-revenue-value" }
const _hoisted_143 = { class: "metrics-revenue-pct" }
const _hoisted_144 = { class: "metrics-revenue-track" }
const _hoisted_145 = { class: "d-flex justify-content-between align-items-baseline" }
const _hoisted_146 = { class: "metrics-revenue-total-label" }
const _hoisted_147 = { class: "metrics-revenue-total-value" }

import {Bar, Line} from 'vue-chartjs'
import {computed, onBeforeMount, ref, Ref, watch} from 'vue'
import {storeToRefs} from 'pinia'
import {useMetricsStore} from '@/services/stores/MetricsStore'
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement, ChartOptions, ChartData,
} from 'chart.js'
import {useI18n} from 'vue-i18n'
import { TopFrequency } from '@/constants/TopFrequency'
import { useThemeStore } from '@/services/stores/ThemeStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'Metrics',
  setup(__props) {

Chart.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, BarElement)
const metricsStore = useMetricsStore()
const {getCurrentYearMetric, getTop5Metric, getTop5MonthlyMetric, getYearRevenueMetric} = metricsStore
const {
  globalYearMetric, canceledYearMetric, completedYearMetric, percentYearMetric, top5DailyMetric, loaded, loading,
  servicesCurrentMonth, servicesDelta, completionRate, completionRateDelta, cancellationRate, cancellationRateDelta,
  topDriverOfMonth,
  commissionCurrentMonth, commissionDelta, monthlyFeeCurrentMonth, monthlyFeeDelta, payingDriverCount,
  rechargeCurrentMonth, rechargeDelta, rechargeCount,
  commissionByMonth, monthlyFeeByMonth,
} = storeToRefs(metricsStore)
const {t} = useI18n()
const theme = useThemeStore()

function gridColor(isDark: boolean): string {
  return isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.1)'
}
function tickColor(isDark: boolean): string {
  return isDark ? 'rgba(255,255,255,0.7)' : '#6c757d'
}
function labelColor(isDark: boolean): string {
  return isDark ? 'rgba(255,255,255,0.8)' : '#212529'
}

function round1(value: number): number {
  return Math.round(value * 10) / 10
}

function formatCurrency(value: number): string {
  return `${Math.round(value).toLocaleString('es-CO')} COP`
}

function formatCurrencyCompact(value: number): string {
  if (value >= 1000000) {
    const millions = Math.round(value / 100000) / 10
    return `$${millions.toLocaleString('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}M`
  }
  return `$${Math.round(value).toLocaleString('es-CO')}`
}

function makeLineOptions(isDark: boolean): ChartOptions {
  return {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: { grid: { color: gridColor(isDark) }, ticks: { color: tickColor(isDark) } },
      y: { grid: { color: gridColor(isDark) }, ticks: { color: tickColor(isDark) } },
    },
    plugins: {
      legend: { display: false },
      title: { color: labelColor(isDark) }
    }
  }
}

function makePercentOptions(isDark: boolean): ChartOptions {
  return {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: { grid: { color: gridColor(isDark) }, ticks: { color: tickColor(isDark) } },
      y: {
        grid: { color: gridColor(isDark) },
        ticks: {
          color: tickColor(isDark),
          callback: function(value) { return value + '%' }
        }
      }
    },
    plugins: {
      legend: { display: false }
    }
  }
}

function makeIncomeOptions(isDark: boolean): ChartOptions {
  return {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: { grid: { color: gridColor(isDark) }, ticks: { color: tickColor(isDark) } },
      y: {
        grid: { color: gridColor(isDark) },
        ticks: {
          color: tickColor(isDark),
          callback: function(value) { return Number(value).toLocaleString('es-CO') }
        }
      }
    },
    plugins: {
      legend: { display: false }
    }
  }
}

const percentChartOptions = ref<ChartOptions>(makePercentOptions(theme.isDark))
const chartOptions = ref<ChartOptions>(makeLineOptions(theme.isDark))
const incomeChartOptions = ref<ChartOptions>(makeIncomeOptions(theme.isDark))
const isLoaded: Ref<boolean> = ref(false)
const isTopLoaded: Ref<boolean> = ref(false)
const frequency = ref<TopFrequency>(TopFrequency.Daily)

let globalChartData: ChartData
let percentChartData: ChartData
let incomeChartData: ChartData

const top5Ranked = computed(() => Array.from(top5DailyMetric.value.entries())
  .map(([plate, count]) => ({ plate, count }))
  .sort((a, b) => b.count - a.count))

const top5Max = computed(() => {
  const counts = top5Ranked.value.map(item => item.count)
  return counts.length ? Math.max(...counts) : 0
})

function top5BarWidth(count: number): number {
  if (top5Max.value <= 0) return 0
  return (count / top5Max.value) * 100
}

const revenueBreakdown = computed(() => {
  const commission = commissionCurrentMonth.value
  const monthlyFee = monthlyFeeCurrentMonth.value
  const recharge = rechargeCurrentMonth.value
  const total = commission + monthlyFee + recharge
  const pct = (value: number) => total > 0 ? Math.round((value / total) * 100) : 0
  return {
    commissionPct: pct(commission),
    monthlyFeePct: pct(monthlyFee),
    rechargePct: pct(recharge),
    total,
  }
})

watch(frequency, async () => {
  isTopLoaded.value = false
  await getTop5Metric(frequency.value)
  isTopLoaded.value = true
})

onBeforeMount(async () => {
  await getTop5Metric(frequency.value)
  if (!loaded.value && !loading.value) await getCurrentYearMetric()
  try {
    await getTop5MonthlyMetric()
  } catch (e) {
    // silent fail — leading-driver card and monthly Top 5 fall back to empty state, non-critical for the rest of the page
  }
  try {
    await getYearRevenueMetric()
  } catch (e) {
    // silent fail — revenue cards/chart degrade to zeros, non-critical for the rest of the page
  }
  isLoaded.value = true
  isTopLoaded.value = true
  const secondary = '#8392ab'
  const success = '#82d616'
  const danger = '#ea0606'
  const dark = '#3a416f'

  globalChartData = {
    labels: Array.from(globalYearMetric.value.keys()),
    datasets: [
      {
        label: t('services.total'),
        data: Array.from(globalYearMetric.value.values()),
        backgroundColor: secondary,
        borderColor: secondary,
        pointBackgroundColor: secondary,
        pointBorderColor: secondary,
        borderWidth: 2,
        borderDash: [5, 4],
        pointRadius: 2,
        pointHoverRadius: 4,
        tension: 0.3,
        fill: false
      },
      {
        label: t('services.statuses.terminated'),
        data: Array.from(completedYearMetric.value.values()),
        backgroundColor: success,
        borderColor: success,
        pointBackgroundColor: success,
        pointBorderColor: success,
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.3,
        fill: false
      },
      {
        label: t('services.statuses.canceled'),
        data: Array.from(canceledYearMetric.value.values()),
        backgroundColor: danger,
        borderColor: danger,
        pointBackgroundColor: danger,
        pointBorderColor: danger,
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.3,
        fill: false
      }
    ]
  }
  percentChartData = {
    labels: Array.from(globalYearMetric.value.keys()),
    datasets: [
      {
        label: t('common.placeholders.cancel_percent'),
        data: Array.from(percentYearMetric.value.values()),
        backgroundColor: danger,
        borderRadius: 6,
        borderSkipped: false,
        maxBarThickness: 28
      }
    ]
  }
  incomeChartData = {
    labels: Array.from(commissionByMonth.value.keys()),
    datasets: [
      {
        label: t('common.placeholders.income_series_commission'),
        data: Array.from(commissionByMonth.value.values()),
        backgroundColor: success,
        borderRadius: 6,
        borderSkipped: false,
        maxBarThickness: 24
      },
      {
        label: t('common.placeholders.income_series_monthly_fee'),
        data: Array.from(monthlyFeeByMonth.value.values()),
        backgroundColor: dark,
        borderRadius: 6,
        borderSkipped: false,
        maxBarThickness: 24
      }
    ]
  }
})

// React to theme changes to update chart options
watch(() => theme.effective, (/*mode*/) => {
  chartOptions.value = makeLineOptions(theme.isDark)
  percentChartOptions.value = makePercentOptions(theme.isDark)
  incomeChartOptions.value = makeIncomeOptions(theme.isDark)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('common.placeholders.kpi_group_service')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('common.placeholders.kpi_services_month')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-info shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-route text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_unref(servicesCurrentMonth).toLocaleString('es-CO')), 1),
                (_unref(servicesDelta) !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["text-sm font-weight-bolder", _unref(servicesDelta) >= 0 ? 'text-success' : 'text-danger'])
                    }, [
                      _createElementVNode("em", {
                        class: _normalizeClass(_unref(servicesDelta) >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(round1(Math.abs(_unref(servicesDelta)))) + "% ", 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('common.placeholders.kpi_completion_rate')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-success shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-circle-check text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h5", _hoisted_18, _toDisplayString(round1(_unref(completionRate))) + "%", 1),
                (_unref(completionRateDelta) !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["text-sm font-weight-bolder", _unref(completionRateDelta) >= 0 ? 'text-success' : 'text-danger'])
                    }, [
                      _createElementVNode("em", {
                        class: _normalizeClass(_unref(completionRateDelta) >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(round1(Math.abs(_unref(completionRateDelta)))) + " pp ", 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('common.placeholders.kpi_cancellation_rate')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-danger shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-ban text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h5", _hoisted_25, _toDisplayString(round1(_unref(cancellationRate))) + "%", 1),
                (_unref(cancellationRateDelta) !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["text-sm font-weight-bolder", _unref(cancellationRateDelta) >= 0 ? 'text-success' : 'text-danger'])
                    }, [
                      _createElementVNode("em", {
                        class: _normalizeClass(_unref(cancellationRateDelta) >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(round1(Math.abs(_unref(cancellationRateDelta)))) + " pp ", 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(t)('common.placeholders.kpi_leading_driver')), 1),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-warning shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-trophy text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_unref(topDriverOfMonth))
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_32, _toDisplayString(_unref(topDriverOfMonth).plate), 1))
                  : (_openBlock(), _createElementBlock("h6", _hoisted_33, _toDisplayString(_unref(t)('common.placeholders.kpi_leading_driver_empty')), 1)),
                (_unref(topDriverOfMonth))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_unref(topDriverOfMonth).count) + " " + _toDisplayString(_unref(t)('common.placeholders.kpi_services_unit')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(t)('common.placeholders.kpi_group_revenue')), 1),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(t)('common.placeholders.kpi_commission_income')), 1),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-success shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-percent text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("h5", _hoisted_44, _toDisplayString(formatCurrencyCompact(_unref(commissionCurrentMonth))), 1),
                (_unref(commissionDelta) !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["text-sm font-weight-bolder", _unref(commissionDelta) >= 0 ? 'text-success' : 'text-danger'])
                    }, [
                      _createElementVNode("em", {
                        class: _normalizeClass(_unref(commissionDelta) >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(round1(Math.abs(_unref(commissionDelta)))) + "% ", 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(t)('common.placeholders.kpi_monthly_fee_income')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-dark shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-file-invoice-dollar text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("h5", _hoisted_51, _toDisplayString(formatCurrencyCompact(_unref(monthlyFeeCurrentMonth))), 1),
                (_unref(monthlyFeeDelta) !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["text-sm font-weight-bolder", _unref(monthlyFeeDelta) >= 0 ? 'text-success' : 'text-danger'])
                    }, [
                      _createElementVNode("em", {
                        class: _normalizeClass(_unref(monthlyFeeDelta) >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(round1(Math.abs(_unref(monthlyFeeDelta)))) + "% ", 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(payingDriverCount)) + " " + _toDisplayString(_unref(t)('common.placeholders.kpi_paying_drivers')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("p", _hoisted_57, _toDisplayString(_unref(t)('common.placeholders.kpi_cash_collected')), 1),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "icon icon-shape bg-gradient-info shadow d-flex align-items-center justify-content-center flex-shrink-0 ms-2 border-radius-md" }, [
                  _createElementVNode("em", { class: "fas fa-money-bill-wave text-lg text-white" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("h5", _hoisted_59, _toDisplayString(formatCurrencyCompact(_unref(rechargeCurrentMonth))), 1),
                (_unref(rechargeDelta) !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["text-sm font-weight-bolder", _unref(rechargeDelta) >= 0 ? 'text-success' : 'text-danger'])
                    }, [
                      _createElementVNode("em", {
                        class: _normalizeClass(_unref(rechargeDelta) >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(round1(Math.abs(_unref(rechargeDelta)))) + "% ", 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_60, _toDisplayString(_unref(rechargeCount)) + " " + _toDisplayString(_unref(t)('common.placeholders.kpi_recharges_count')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icon icon-shape icon-sm bg-gradient-info shadow text-center border-radius-md d-flex align-items-center justify-content-center me-2" }, [
              _createElementVNode("em", { class: "fas fa-chart-line text-white text-xs" })
            ], -1)),
            _createElementVNode("h6", _hoisted_65, _toDisplayString(_unref(t)('common.placeholders.year_service_progress')), 1),
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("span", _hoisted_66))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "metrics-legend-swatch metrics-legend-swatch--square bg-secondary" }, null, -1)),
                _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(t)('services.total')), 1)
              ]),
              _createElementVNode("span", _hoisted_71, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "metrics-legend-swatch bg-success" }, null, -1)),
                _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(t)('services.statuses.terminated')), 1)
              ]),
              _createElementVNode("span", _hoisted_73, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "metrics-legend-swatch bg-danger" }, null, -1)),
                _createElementVNode("span", _hoisted_74, _toDisplayString(_unref(t)('services.statuses.canceled')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              (isLoaded.value)
                ? (_openBlock(), _createBlock(_unref(Line), {
                    key: 0,
                    id: "global-chart",
                    options: chartOptions.value,
                    data: _unref(globalChartData)
                  }, null, 8, ["options", "data"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_76, [
              (!isLoaded.value)
                ? (_openBlock(), _createElementBlock("em", _hoisted_77))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "icon icon-shape icon-sm bg-gradient-danger shadow text-center border-radius-md d-flex align-items-center justify-content-center me-2" }, [
              _createElementVNode("em", { class: "fas fa-chart-column text-white text-xs" })
            ], -1)),
            _createElementVNode("h6", _hoisted_81, _toDisplayString(_unref(t)('common.placeholders.cancel_percent')), 1)
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("span", _hoisted_84, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "metrics-legend-swatch bg-danger" }, null, -1)),
                _createElementVNode("span", _hoisted_85, _toDisplayString(_unref(t)('common.placeholders.cancel_percent')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              (isLoaded.value)
                ? (_openBlock(), _createBlock(_unref(Bar), {
                    key: 0,
                    id: "percent-chart",
                    options: percentChartOptions.value,
                    data: _unref(percentChartData)
                  }, null, 8, ["options", "data"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_87, [
              (!isLoaded.value)
                ? (_openBlock(), _createElementBlock("em", _hoisted_88))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "icon icon-shape icon-sm bg-gradient-primary shadow text-center border-radius-md d-flex align-items-center justify-content-center me-2" }, [
              _createElementVNode("em", { class: "fas fa-ranking-star text-white text-xs" })
            ], -1)),
            _createElementVNode("h6", _hoisted_92, _toDisplayString(_unref(t)('common.placeholders.top5_title')), 1),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["metrics-segment__btn", { 'metrics-segment__btn--active': frequency.value === _unref(TopFrequency).Daily }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (frequency.value = _unref(TopFrequency).Daily))
              }, _toDisplayString(_unref(t)('common.placeholders.top5_period_day')), 3),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["metrics-segment__btn", { 'metrics-segment__btn--active': frequency.value === _unref(TopFrequency).Weekly }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (frequency.value = _unref(TopFrequency).Weekly))
              }, _toDisplayString(_unref(t)('common.placeholders.top5_period_week')), 3),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["metrics-segment__btn", { 'metrics-segment__btn--active': frequency.value === _unref(TopFrequency).Monthly }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (frequency.value = _unref(TopFrequency).Monthly))
              }, _toDisplayString(_unref(t)('common.placeholders.top5_period_month')), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_94, [
            (isTopLoaded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  (top5Ranked.value.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString(_unref(t)('common.placeholders.top5_empty')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(top5Ranked.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.plate,
                            class: "metrics-top5-row"
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["metrics-top5-rank", { 'metrics-top5-rank--first': index === 0 }])
                            }, _toDisplayString(index + 1), 3),
                            _createElementVNode("span", _hoisted_98, _toDisplayString(item.plate), 1),
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("div", {
                                class: "metrics-top5-fill",
                                style: _normalizeStyle({ width: top5BarWidth(item.count) + '%', opacity: 1 - index * 0.15 })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_100, _toDisplayString(item.count), 1)
                          ]))
                        }), 128))
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_101, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("em", { class: "fa-solid fa-spinner fa-10x circle" }, null, -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "icon icon-shape icon-sm bg-gradient-success shadow text-center border-radius-md d-flex align-items-center justify-content-center me-2" }, [
              _createElementVNode("em", { class: "fas fa-sack-dollar text-white text-xs" })
            ], -1)),
            _createElementVNode("h6", _hoisted_106, _toDisplayString(_unref(t)('common.placeholders.income_by_charge_type')), 1)
          ]),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("span", _hoisted_109, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "metrics-legend-swatch bg-success" }, null, -1)),
                _createElementVNode("span", _hoisted_110, _toDisplayString(_unref(t)('common.placeholders.income_series_commission')), 1)
              ]),
              _createElementVNode("span", _hoisted_111, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "metrics-legend-swatch metrics-legend-swatch--dark-navy" }, null, -1)),
                _createElementVNode("span", _hoisted_112, _toDisplayString(_unref(t)('common.placeholders.income_series_monthly_fee')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_113, [
              (isLoaded.value)
                ? (_openBlock(), _createBlock(_unref(Bar), {
                    key: 0,
                    id: "income-chart",
                    options: incomeChartOptions.value,
                    data: _unref(incomeChartData)
                  }, null, 8, ["options", "data"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_114, [
              (!isLoaded.value)
                ? (_openBlock(), _createElementBlock("em", _hoisted_115))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_116, [
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "icon icon-shape icon-sm metrics-icon-slate shadow text-center border-radius-md d-flex align-items-center justify-content-center me-2" }, [
              _createElementVNode("em", { class: "fas fa-scale-balanced text-white text-xs" })
            ], -1)),
            _createElementVNode("h6", _hoisted_119, _toDisplayString(_unref(t)('common.placeholders.income_breakdown')), 1)
          ]),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_124, _toDisplayString(_unref(t)('common.placeholders.income_series_commission')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, _toDisplayString(formatCurrency(_unref(commissionCurrentMonth))), 1),
                    _createElementVNode("div", _hoisted_127, _toDisplayString(revenueBreakdown.value.commissionPct) + "%", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", {
                    class: "metrics-revenue-fill bg-success",
                    style: _normalizeStyle({ width: revenueBreakdown.value.commissionPct + '%' })
                  }, null, 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_131, _toDisplayString(_unref(t)('common.placeholders.income_series_monthly_fee')), 1),
                    _createElementVNode("div", _hoisted_132, _toDisplayString(_unref(payingDriverCount)) + " " + _toDisplayString(_unref(t)('common.placeholders.kpi_paying_drivers')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, _toDisplayString(formatCurrency(_unref(monthlyFeeCurrentMonth))), 1),
                    _createElementVNode("div", _hoisted_135, _toDisplayString(revenueBreakdown.value.monthlyFeePct) + "%", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", {
                    class: "metrics-revenue-fill metrics-revenue-fill--dark-navy",
                    style: _normalizeStyle({ width: revenueBreakdown.value.monthlyFeePct + '%' })
                  }, null, 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_139, _toDisplayString(_unref(t)('common.placeholders.kpi_cash_collected')), 1),
                    _createElementVNode("div", _hoisted_140, _toDisplayString(_unref(rechargeCount)) + " " + _toDisplayString(_unref(t)('common.placeholders.kpi_recharges_count')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, _toDisplayString(formatCurrency(_unref(rechargeCurrentMonth))), 1),
                    _createElementVNode("div", _hoisted_143, _toDisplayString(revenueBreakdown.value.rechargePct) + "%", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_144, [
                  _createElementVNode("div", {
                    class: "metrics-revenue-fill bg-info",
                    style: _normalizeStyle({ width: revenueBreakdown.value.rechargePct + '%' })
                  }, null, 4)
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "metrics-revenue-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("span", _hoisted_146, _toDisplayString(_unref(t)('common.placeholders.income_total')), 1),
                _createElementVNode("span", _hoisted_147, _toDisplayString(formatCurrency(revenueBreakdown.value.total)), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})